/** Split a reasoning block into one bullet per sentence or line so a wall of
 *  chain-of-thought reads as scannable plan steps. List markers like "1." stay attached
 *  to their text because the sentence split requires a non-digit before the punctuation. */
export const reasoningBullets = (text: string): string[] =>
  text
    .split(/\r?\n/)
    .flatMap((line) => line.split(/(?<=\D[.!?])\s+/))
    .map((piece) => piece.trim())
    .filter((piece) => piece.length > 0);
